import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';

import { Label } from 'components';

const TextField = ({
  label,
  suffix,
  containerClassName,
  className,
  asterisk = false,
  ...rest
}) => {
  return (
    <div className={containerClassName || ''}>
      <Label label={label} asterisk={asterisk}/>
      <Input
        {...rest}
        className={`custom-textfield ${className}`}
        suffix={suffix}
      />
    </div>
  );
};

TextField.propTypes = {
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  className: PropTypes.string,
};

export default TextField;
